module.exports = __webpack_public_path__ + "static/media/intro-desktop.ce59df09.webp";